import api from '@/shared/api/client';

/**
 * Délégation de droits au rôle du dessous.
 *
 * Deux appels, et AUCUNE liste de capacités écrite ici. Ce que l'admin peut ouvrir est
 * décidé par `DELEGABLES` dans `backend/app/core/authz.py`, et arrive par la réponse de
 * `getDelegations`. Recopier cette liste dans du React en ferait une seconde source de
 * vérité, qui dériverait le jour où une capacité y est ajoutée sans que personne pense
 * au front — exactement ce que `shared/auth/capacites.js` explique en tête.
 *
 * ⚠️ Cocher une case ne PROTÈGE rien. Le refus reste posé sur le chemin de chaque
 * requête par `require_cap`. Cet écran pose une valeur, le serveur décide.
 */

export const getDelegations = () => api.get('/admin/delegations').then((r) => r.data);

/**
 * `roles` : `{ commercial: ['clients:agregateur'] }` — la liste de ce qui est OUVERT.
 *
 * L'écriture est totale pour les rôles envoyés et ne touche pas les autres : deux
 * onglets ouverts en même temps sur deux rôles différents ne s'écrasent pas.
 */
export const majDelegations = (roles) =>
  api.put('/admin/delegations', { roles }).then((r) => r.data);
